export default __webpack_public_path__ + "static/media/mo-complex-layout-12-1@2x.b8f0c2d4.png";